import { Coordinates } from '@/types/commons/commons.types';

import { C2_URL, c2Api } from './c2.api';

export const engagementApi = c2Api.injectEndpoints({
  endpoints: (builder) => ({
    prepareEngagedTarget: builder.mutation<void, null | string>({
      query: (targetId) => ({
        url: `${C2_URL}/engagement/target`,
        method: 'POST',
        params: {
          targetId,
        },
      }),
    }),
    prepareEngagedPosition: builder.mutation<void, null | Coordinates>({
      query: (coordinates) => ({
        url: `${C2_URL}/engagement/position`,
        method: 'POST',
        body: coordinates ?? { type: '2D', latitude: null, longitude: null },
      }),
    }),
  }),
});

export const { usePrepareEngagedPositionMutation, usePrepareEngagedTargetMutation } = engagementApi;
